import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyDetailsRoutingModule } from './company-details-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';

import { CompanyDetailsComponent } from './company-details/company-details.component';
import { CompanyDetailsNavbarComponent } from './company-details-navbar/company-details-navbar.component';
import { CompanyDetailsHeaderComponent } from './company-details-header/company-details-header.component';
import { CompanyDetailsGeneralComponent } from './company-details-general/company-details-general.component';
import { CompanyDetailsGeneralInfoComponent } from './company-details-general-info/company-details-general-info.component';
import { CompanyDetailsGeneralPaymentMethodsComponent } from './company-details-general-payment-methods/company-details-general-payment-methods.component';
import { CompanyDetailsGeneralContractsComponent } from './company-details-general-contracts/company-details-general-contracts.component';
import { CompanyDetailsGeneralSettingsComponent } from './company-details-general-settings/company-details-general-settings.component';
import { CompanyDetailsStoreDataComponent } from './company-details-store-data/company-details-store-data.component';
import { CompanyDetailsStoreDataTableComponent } from './company-details-store-data-table/company-details-store-data-table.component';
import { CompanyDetailsTeamDataComponent } from './company-details-team-data/company-details-team-data.component';
import { CompanyDetailsTeamDataTableComponent } from './company-details-team-data-table/company-details-team-data-table.component';
import { CompanyDetailsEventDataComponent } from './company-details-event-data/company-details-event-data.component';
import { CompanyDetailsPendingInvitationsDataComponent } from './company-details-pending-invitations-data/company-details-pending-invitations-data.component';
import { CompanyDetailsPendingInvitationsDataTableComponent } from './company-details-pending-invitations-data-table/company-details-pending-invitations-data-table.component';
import { CompanyDetailsOrderDataComponent } from './company-details-order-data/company-details-order-data.component';
import { CompanyDetailsOrderDataTableComponent } from './company-details-order-data-table/company-details-order-data-table.component';
import { CompanyDetailsUnpaidDataComponent } from './company-details-unpaid-data/company-details-unpaid-data.component';
import { CompanyDetailsUnpaidDataTableComponent } from './company-details-unpaid-data-table/company-details-unpaid-data-table.component';

@NgModule({
  declarations: [
    CompanyDetailsComponent,
    CompanyDetailsNavbarComponent,
    CompanyDetailsHeaderComponent,
    CompanyDetailsGeneralComponent,
    CompanyDetailsGeneralInfoComponent,
    CompanyDetailsGeneralPaymentMethodsComponent,
    CompanyDetailsGeneralContractsComponent,
    CompanyDetailsGeneralSettingsComponent,
    CompanyDetailsStoreDataComponent,
    CompanyDetailsStoreDataTableComponent,
    CompanyDetailsTeamDataComponent,
    CompanyDetailsTeamDataTableComponent,
    CompanyDetailsEventDataComponent,
    CompanyDetailsPendingInvitationsDataComponent,
    CompanyDetailsPendingInvitationsDataTableComponent,
    CompanyDetailsOrderDataComponent,
    CompanyDetailsOrderDataTableComponent,
    CompanyDetailsUnpaidDataComponent,
    CompanyDetailsUnpaidDataTableComponent,
  ],
  imports: [
    CommonModule,
    CompanyDetailsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatBadgeModule,
  ],
})
export class CompanyDetailsModule {}
